import translate from '../i18n/config';

export const API_PREFIX = '/api/v1/';

export const API_URL = process.env.REACT_APP_API_URL;
export const COMPILER_URL = process.env.REACT_APP_COMPILER_URL;

const ENTITY = {
  auth: 'auth',
  users: 'users',
  roles: 'roles',
  tasks: 'task',
  genericLookup: 'generic-lookup',
  tenant: 'tenant',
  stockists: 'stockists',
  stockistBranches: 'stockist-branches',
  stockistProducts: 'stockist-products',
  config: 'config',
  templates: 'templates',
  templateHeaders: 'template-headers',
  productDivisions: 'product-divisions',
  products: 'products',
  monthlyStock: 'monthly-stock',
  dashboard: 'dashboard',
};

export const PATH = {
  login: 'login',
  logout: 'logout',
  forgotPassword: 'forgot-password',
  resetPassword: 'reset-password',
  search: 'search',
  lookup: 'lookup',
  changePassword: 'change-password',
  kpis: 'kpi',
  validate: 'validate',
  genericLookup: 'generic-lookup',
  geoLookup: 'geo-lookup',
  template: 'template',
  upload: 'upload',
};

const API_PATHS = {
  login: `${ENTITY.auth}/${PATH.login}`,
  logout: `${ENTITY.auth}/${PATH.logout}`,
  forgotPassword: `${ENTITY.auth}/${PATH.forgotPassword}`,
  resetPassword: `${ENTITY.auth}/${PATH.resetPassword}`,
  listUsers: `${ENTITY.users}`,
  users: `${ENTITY.users}`,
  changePassword: `${ENTITY.users}/${PATH.changePassword}`,
  userListKpis: `${ENTITY.users}/${PATH.kpis}`,
  listRoles: `${ENTITY.roles}/${PATH.search}`,
  lookupUsers: `${ENTITY.users}/${PATH.lookup}`,
  lookupRoles: `${ENTITY.roles}/${PATH.lookup}`,
  lookupGeneric: `${ENTITY.genericLookup}/${PATH.lookup}`,
  listTasks: `${ENTITY.tasks}/${PATH.search}`,
  tasks: `${ENTITY.tasks}`,
  taskKpis: `${ENTITY.tasks}/${PATH.kpis}`,
  tenantValidate: `${ENTITY.tenant}/${PATH.validate}`,
  listStockists: `${ENTITY.stockists}`,
  stockists: `${ENTITY.stockists}`,
  lookupStockists: `${ENTITY.stockists}/${PATH.lookup}`,
  listStockistBranches: `${ENTITY.stockistBranches}`,
  stockistBranches: `${ENTITY.stockistBranches}`,
  lookupStockistBranches: `${ENTITY.stockistBranches}/${PATH.lookup}`,
  listStockistProducts: `${ENTITY.stockistProducts}`,
  stockistProducts: `${ENTITY.stockistProducts}`,
  configLookup: `${ENTITY.config}/${PATH.genericLookup}`,
  geoLookup: `${ENTITY.config}/${PATH.geoLookup}`,
  listTemplates: `${ENTITY.templates}`,
  templates: `${ENTITY.templates}`,
  listTemplateHeaders: `${ENTITY.templateHeaders}/${PATH.lookup}`,
  getTemplateHeaders: `${ENTITY.templateHeaders}/${PATH.template}`,
  lookupTemplates: `${ENTITY.templates}/${PATH.lookup}`,
  listProductDivisions: `${ENTITY.productDivisions}`,
  productDivisions: `${ENTITY.productDivisions}`,
  lookupProductDivisions: `${ENTITY.productDivisions}/${PATH.lookup}`,
  listProducts: `${ENTITY.products}`,
  products: `${ENTITY.products}`,
  lookupProducts: `${ENTITY.products}/${PATH.lookup}`,
  suggestionsProducts: `${ENTITY.products}/suggestions`,
  mapStockistProduct: `${ENTITY.monthlyStock}`,
  submitMonthlyStock: `${ENTITY.monthlyStock}`,
  updateMonthlyStockStatus: `${ENTITY.monthlyStock}`,
  listMonthlyStock: `${ENTITY.monthlyStock}`,
  uploadMonthlyStock: `${ENTITY.monthlyStock}/${PATH.upload}`,
  monthlyStockSummary: `${ENTITY.monthlyStock}`,
  monthlyStockDetails: `${ENTITY.monthlyStock}`,
  monthlyStockVerifyData: `${ENTITY.monthlyStock}`,
  monthlyStockDownloadUrl: `${ENTITY.monthlyStock}`,
  dashboardCompanySecondary: `${ENTITY.dashboard}/company-secondary`,
  dashboardZoneWiseSecondaryClosing: `${ENTITY.dashboard}/zone-wise-secondary-closing`,
  dashboardDivisionSecondary: `${ENTITY.dashboard}/division-secondary`,
  dashboardTopSKUs: `${ENTITY.dashboard}/top-skus`,
  dashboardAvgInventoryDays: `${ENTITY.dashboard}/avg-inventory-days`,
};

export const API_ENDPOINTS = {
  login: API_PREFIX + API_PATHS.login,
  logout: API_PREFIX + API_PATHS.logout,
  forgotPassword: API_PREFIX + API_PATHS.forgotPassword,
  resetPassword: API_PREFIX + API_PATHS.resetPassword,
  listUsers: API_PREFIX + API_PATHS.listUsers,
  addUser: API_PREFIX + API_PATHS.users,
  editUser: API_PREFIX + API_PATHS.users,
  changePassword: API_PREFIX + API_PATHS.changePassword,
  getUser: API_PREFIX + API_PATHS.users,
  lookupUsers: API_PREFIX + API_PATHS.lookupUsers,
  userListKpis: API_PREFIX + API_PATHS.userListKpis,
  listRoles: API_PREFIX + API_PATHS.listRoles,
  lookupRoles: API_PREFIX + API_PATHS.lookupRoles,
  configLookup: API_PREFIX + API_PATHS.configLookup,
  geoLookup: API_PREFIX + API_PATHS.geoLookup,
  listTasks: API_PREFIX + API_PATHS.listTasks,
  addTask: API_PREFIX + API_PATHS.tasks,
  editTask: API_PREFIX + API_PATHS.tasks,
  getTask: API_PREFIX + API_PATHS.tasks,
  taskKpis: API_PREFIX + API_PATHS.taskKpis,
  tenantValidate: API_PREFIX + API_PATHS.tenantValidate,
  listStockists: API_PREFIX + API_PATHS.listStockists,
  addStockist: API_PREFIX + API_PATHS.stockists,
  editStockist: API_PREFIX + API_PATHS.stockists,
  getStockist: API_PREFIX + API_PATHS.stockists,
  deleteStockist: API_PREFIX + API_PATHS.stockists,
  lookupStockists: API_PREFIX + API_PATHS.lookupStockists,
  listStockistBranches: API_PREFIX + API_PATHS.listStockistBranches,
  lookupStockistBranches: API_PREFIX + API_PATHS.lookupStockistBranches,
  addStockistBranch: API_PREFIX + API_PATHS.stockistBranches,
  editStockistBranch: API_PREFIX + API_PATHS.stockistBranches,
  getStockistBranch: API_PREFIX + API_PATHS.stockistBranches,
  deleteStockistBranch: API_PREFIX + API_PATHS.stockistBranches,
  listStockistProducts: API_PREFIX + API_PATHS.listStockistProducts,
  addStockistProduct: API_PREFIX + API_PATHS.stockistProducts,
  editStockistProduct: API_PREFIX + API_PATHS.stockistProducts,
  getStockistProduct: API_PREFIX + API_PATHS.stockistProducts,
  deleteStockistProduct: API_PREFIX + API_PATHS.stockistProducts,
  extractMonthlyStock: '/extract',
  listMonthlyStock: API_PREFIX + API_PATHS.listMonthlyStock,
  uploadMonthlyStock: API_PREFIX + API_PATHS.uploadMonthlyStock,
  getMonthlyStockSummary: API_PREFIX + API_PATHS.monthlyStockSummary,
  getMonthlyStockDetails: API_PREFIX + API_PATHS.monthlyStockDetails,
  getMonthlyStockVerifyData: API_PREFIX + API_PATHS.monthlyStockVerifyData,
  getMonthlyStockDownloadUrl: API_PREFIX + API_PATHS.monthlyStockDownloadUrl,
  listTemplates: API_PREFIX + API_PATHS.listTemplates,
  addTemplate: API_PREFIX + API_PATHS.templates,
  editTemplate: API_PREFIX + API_PATHS.templates,
  getTemplate: API_PREFIX + API_PATHS.templates,
  listTemplateHeaders: API_PREFIX + API_PATHS.listTemplateHeaders,
  getTemplateHeaders: API_PREFIX + API_PATHS.getTemplateHeaders,
  lookupTemplates: API_PREFIX + API_PATHS.lookupTemplates,
  listProductDivisions: API_PREFIX + API_PATHS.listProductDivisions,
  addProductDivision: API_PREFIX + API_PATHS.productDivisions,
  editProductDivision: API_PREFIX + API_PATHS.productDivisions,
  getProductDivision: API_PREFIX + API_PATHS.productDivisions,
  lookupProductDivisions: API_PREFIX + API_PATHS.lookupProductDivisions,
  listProducts: API_PREFIX + API_PATHS.listProducts,
  addProduct: API_PREFIX + API_PATHS.products,
  editProduct: API_PREFIX + API_PATHS.products,
  getProduct: API_PREFIX + API_PATHS.products,
  lookupProducts: API_PREFIX + API_PATHS.lookupProducts,
  suggestionsProducts: API_PREFIX + API_PATHS.suggestionsProducts,
  mapStockistProduct: API_PREFIX + API_PATHS.mapStockistProduct,
  submitMonthlyStock: API_PREFIX + API_PATHS.submitMonthlyStock,
  updateMonthlyStockStatus: API_PREFIX + API_PATHS.updateMonthlyStockStatus,
  dashboardCompanySecondary: API_PREFIX + API_PATHS.dashboardCompanySecondary,
  dashboardZoneWiseSecondaryClosing: API_PREFIX + API_PATHS.dashboardZoneWiseSecondaryClosing,
  dashboardDivisionSecondary: API_PREFIX + API_PATHS.dashboardDivisionSecondary,
  dashboardTopSKUs: API_PREFIX + API_PATHS.dashboardTopSKUs,
  dashboardAvgInventoryDays: API_PREFIX + API_PATHS.dashboardAvgInventoryDays,
};

export const STATUS_CODE = {
  unauthorized: 401,
  badRequest: 400,
  unProcessableEntity: 422,
  forbidden: 403,
  notFound: 404,
  internalServerError: 500,
  gatewayTimeout: 504,
  entityTooLarge: 413,
  conflict: 409,
};

export const ERROR_MESSAGES = {
  internalServerError: translate.t('common.errorMessages.internalServerError'),
  unauthorized: translate.t('common.errorMessages.unauthorized'),
  badRequest: translate.t('common.errorMessages.badRequest'),
  apiPathNotFound: translate.t('common.errorMessages.apiPathNotFound'),
  forbidden: translate.t('common.errorMessages.forbidden'),
  gatewayTimeout: translate.t('common.errorMessages.gatewayTimeout'),
};
